import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  ViewContainerRef,
  ComponentFactoryResolver,
  Type,
  ComponentRef,
  ChangeDetectorRef
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators,
  UntypedFormGroup
} from '@angular/forms';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { CommonConfirmationModalData } from 'src/app/components/common/common-confirmation-modal/common-confirmation-modal.component.model';
import {
  PaymentAccount,
  Actions,
  PaymentProcessorType,
  PaymentProcessor,
  PaymentProcessorAccountConfigurationBase
} from '../../../../models';
import {
  FeeRecipient,
  FeeRecipientGenerationImpactReport,
  FeeRecipientGenerationRequest,
  WorkflowFeeRecipientItem
} from 'src/app/models/fee-recipient';
import {
  WorkflowContextService,
  SystemService,
  ClientService,
  SecurityService,
  Utilities
} from '../../../../services';
import { PaymentAccountConfigBaseComponent } from '../../../../components/payment-account/payment-account-config-base/payment-account-config-base.component';
import { PaymentAccountConfigCertifiedpaymentsComponent } from '../../../../components/payment-account/payment-account-config-certifiedpayments/payment-account-config-certifiedpayments.component';
import { CertifiedPaymentsPaymentProcessorAccountConfiguration } from 'src/app/models/payment-providers/certifiedpayments/certifiedpayments-payment-processor-account-configuration';
import { PaymentAccountConfigForteCheckoutComponent } from 'src/app/components/payment-account/payment-account-config-forte-checkout/payment-account-config-forte-checkout.component';
import { ForteCheckoutPaymentProcessorAccountConfiguration } from 'src/app/models/payment-providers/fortecheckout/fortecheckout-payment-processor-account-configuration';
import { CarrollCountyPaymentProcessorAccountConfiguration } from 'src/app/models/payment-providers/carrollcounty/carrollcounty-payment-processor-account-configuration';
import { PaymentAccountConfigOfficialpaymentsComponent } from '../../../../components/payment-account/payment-account-config-officialpayments/payment-account-config-officialpayments.component';
import { OfficialpaymentsPaymentProcessorAccountConfiguration } from 'src/app/models/payment-providers/officialpayments/officialpayments-payment-processor-account-configuration';
import { PaymentAccountConfigKanpayComponent } from '../../../../components/payment-account/payment-account-config-kanpay/payment-account-config-kanpay.component';
import { KanPayPaymentProcessorAccountConfiguration } from 'src/app/models/payment-providers/kanpay/kanpay-payment-processor-account-configuration';
import { PaymentAccountConfigMunicipayComponent } from '../../../../components/payment-account/payment-account-config-municipay/payment-account-config-municipay.component';
import { MunicipayPaymentProcessorAccountConfiguration } from 'src/app/models/payment-providers/municipay/municipay-payment-processor-account-configuration';
import { PaymentAccountConfigPointnpayComponent } from '../../../../components/payment-account/payment-account-config-pointnpay/payment-account-config-pointnpay.component';
import { PointNPayPaymentProcessorAccountConfiguration } from 'src/app/models/payment-providers/pointnpay/pointnpay-payment-processor-account-configuration';
import { PaymentAccountConfigNmiComponent } from '../../../../components/payment-account/payment-account-config-nmi/payment-account-config-nmi.component';
import { NmiPaymentProcessorAccountConfiguration } from 'src/app/models/payment-providers/nmi/nmi-payment-processor-account-configuration';
import { PaymentAccountConfigVpsComponent } from '../../../../components/payment-account/payment-account-config-vps/payment-account-config-vps.component';
import { VpsPaymentProcessorAccountConfiguration } from 'src/app/models/payment-providers/vps/vps-payment-processor-account-configuration';
import { PaymentAccountConfigForteComponent } from '../../../../components/payment-account/payment-account-config-forte/payment-account-config-forte.component';
import { FortePaymentProcessorAccountConfiguration } from 'src/app/models/payment-providers/forte/forte-payment-processor-account-configuration';
import { PaymentAccountConfigPaygovComponent } from '../../../../components/payment-account/payment-account-config-paygov/payment-account-config-paygov.component';
import { PayGovPaymentProcessorAccountConfiguration } from '../../../../models';
import { PaymentAccountConfigSquareComponent } from '../../../../components/payment-account/payment-account-config-square/payment-account-config-square.component';
import { SquarePaymentProcessorAccountConfiguration } from 'src/app/models/payment-providers/square/square-payment-processor-account-configuration';
import { PaymentAccountConfigeGOVComponent } from '../../../../components/payment-account/payment-account-config-egov/payment-account-config-egov.component';
import { eGOVPaymentProcessorAccountConfiguration } from 'src/app/models/payment-providers/egov/egov-payment-processor-account-configuration';
import { PaymentAccountConfigPsnComponent } from '../../../../components/payment-account/payment-account-config-psn/payment-account-config-psn.component';
import { PSNPaymentProcessorAccountConfiguration } from 'src/app/models/payment-providers/psn/psn-payment-processor-account-configuration';
import { PaymentAccountConfigGovPayComponent } from '../../../../components/payment-account/payment-account-config-govpay/payment-account-config-govpay.component';
import { GovPayPaymentProcessorAccountConfiguration } from 'src/app/models/payment-providers/govpay/govpay-payment-processor-account-configuration';
import { PaymentAccountConfigSecurepayComponent } from '../../../../components/payment-account/payment-account-config-securepay/payment-account-config-securepay.component';
import { SecurepayPaymentProcessorAccountConfiguration } from 'src/app/models/payment-providers/securepay/securepay-payment-processor-account-configuration';
import { PaymentAccountConfigCardpointeComponent } from '../../../../components/payment-account/payment-account-config-cardpointe/payment-account-config-cardpointe.component';
import { CardpointePaymentProcessorAccountConfiguration } from 'src/app/models/payment-providers/cardpointe/cardpointe-payment-processor-account-configuration';
import { PaymentAccountConfigCarrollCountyComponent } from 'src/app/components/payment-account/payment-account-config-carrollcounty/payment-account-config-carrollcounty.component';
import { GWPaymentProcessorAccountConfiguration } from 'src/app/models/payment-providers/gw/gw-payment-processor-account-configuration';
import { PaymentAccountConfigGWComponent } from 'src/app/components/payment-account/payment-account-config-gw/payment-account-config-gw.component';
import { PaymentAccountConfigCityHallSystemComponent } from 'src/app/components/payment-account/payment-account-config-cityhallsystem/payment-account-config-cityhallsystem.component';
import { CityHallSystemPaymentProcessorAccountConfiguration } from 'src/app/models/payment-providers/cityhallsystem/cityhallsystem-payment-processor-account-configuration';
import { UnibankPaymentProcessorAccountConfiguration } from 'src/app/models/payment-providers/unibank/unibank-payment-processor-account-configuration';
import { PaymentAccountConfigUnibankComponent } from 'src/app/components/payment-account/payment-account-config-unibank/payment-account-config-unibank.component';
import { InvoiceCloudPaymentProcessorAccountConfiguration } from 'src/app/models/payment-providers/invoicecloud/invoicecloud-payment-processor-account-configuration';
import { PaymentAccountConfigInvoiceCloudComponent } from 'src/app/components/payment-account/payment-account-config-invoicecloud/payment-account-config-invoicecloud.component';
@Component({
  selector: 'wm-settings-payments',
  standalone: false,
  templateUrl: './settings-payments.component.html',
  styleUrls: ['./settings-payments.component.scss']
})
export class SettingsPaymentsComponent implements OnInit, OnDestroy {
  @ViewChild('prodProviderConfigView', {
    read: ViewContainerRef,
    static: false
  })
  prodItemViewContainer: ViewContainerRef;
  @ViewChild('testProviderConfigView', {
    read: ViewContainerRef,
    static: false
  })
  testItemViewContainer: ViewContainerRef;

  activeTab: 'accounts' | 'recipients' = 'accounts';

  showInlineEditor = false;
  showFeeReportOverlay = false;

  editorType: 'account' | 'recipient' = 'account';
  isSaving = false;

  isLoadingAccounts = false;

  accountForm: FormGroup;
  recipientForm: FormGroup;
  prodForm: UntypedFormGroup;
  testForm: UntypedFormGroup;

  paymentAccounts: PaymentAccount[] = [];
  feeRecipients: FeeRecipient[] = [];
  availableProcessors: PaymentProcessor[] = [];

  configComponents: {
    [key: number]: Type<PaymentAccountConfigBaseComponent>;
  } = {};
  configTypes: { [key: number]: any } = {};

  prodComponentRef: ComponentRef<PaymentAccountConfigBaseComponent>;
  testComponentRef: ComponentRef<PaymentAccountConfigBaseComponent>;

  selectedAccount: PaymentAccount;
  activeConfigTab: 'live' | 'test' = 'live';

  isDropdownOpen = false;
  selectedProcessorName: string = 'Select Payment Provider';

  private clientSubscription: Subscription;
  private routerSub$: Subscription;
  private editingFeeRecipientId: string | null = null;
  isEditingAccount = false;
  activeEditId: string | null = null;

  canGenerateFeeRecipients = false;
  feeRecipientGenerationImpactReport: FeeRecipientGenerationImpactReport;
  waitingOnReport = false;

  confirmData: CommonConfirmationModalData = {
    open: false,
    modalDescp: '',
    modalSubDescp: '',
    yesNoBtn: true,
    inTime: 300,
    outTime: 200,
    status: 'default'
  };
  private pendingAction:
    | 'DELETE_ACCOUNT'
    | 'DELETE_RECIPIENT'
    | 'TOGGLE_MODE'
    | 'TOGGLE_ENABLED'
    | null = null;
  private pendingId: string | null = null;

  constructor(
    private fb: FormBuilder,
    private _context: WorkflowContextService,
    private _systemSvc: SystemService,
    private _clientSvc: ClientService,
    private _router: Router,
    private _route: ActivatedRoute,
    private _toastr: ToastrService,
    private _securitySvc: SecurityService,
    private componentFactoryResolver: ComponentFactoryResolver,
    private ref: ChangeDetectorRef
  ) {
    this.prodForm = this.fb.group({});
    this.testForm = this.fb.group({});

    this.accountForm = this.fb.group({
      name: ['', Validators.required],
      processor: [null, Validators.required],
      prodForm: this.prodForm,
      testForm: this.testForm
    });

    this.recipientForm = this.fb.group({
      name: ['', Validators.required]
    });

    this.initializeProviderMaps();
  }

  initializeProviderMaps() {
    this.configComponents[
      PaymentProcessorType.CertifiedPayments
    ] = PaymentAccountConfigCertifiedpaymentsComponent;
    this.configComponents[
      PaymentProcessorType.ForteCheckout
    ] = PaymentAccountConfigForteCheckoutComponent;
    this.configComponents[
      PaymentProcessorType.GW
    ] = PaymentAccountConfigGWComponent;
    this.configComponents[
      PaymentProcessorType.Unibank
    ] = PaymentAccountConfigUnibankComponent;
    this.configComponents[
      PaymentProcessorType.CityHallSystem
    ] = PaymentAccountConfigCityHallSystemComponent;
    this.configComponents[
      PaymentProcessorType.InvoiceCloud
    ] = PaymentAccountConfigInvoiceCloudComponent;
    this.configComponents[
      PaymentProcessorType.OfficialPayments
    ] = PaymentAccountConfigOfficialpaymentsComponent;
    this.configComponents[
      PaymentProcessorType.KanPay
    ] = PaymentAccountConfigKanpayComponent;
    this.configComponents[
      PaymentProcessorType.Municipay
    ] = PaymentAccountConfigMunicipayComponent;
    this.configComponents[
      PaymentProcessorType.PointNPay
    ] = PaymentAccountConfigPointnpayComponent;
    this.configComponents[
      PaymentProcessorType.NMI
    ] = PaymentAccountConfigNmiComponent;
    this.configComponents[
      PaymentProcessorType.VPS
    ] = PaymentAccountConfigVpsComponent;
    this.configComponents[
      PaymentProcessorType.Forte
    ] = PaymentAccountConfigForteComponent;
    this.configComponents[
      PaymentProcessorType.PayGov
    ] = PaymentAccountConfigPaygovComponent;
    this.configComponents[
      PaymentProcessorType.Square
    ] = PaymentAccountConfigSquareComponent;
    this.configComponents[
      PaymentProcessorType.eGOV
    ] = PaymentAccountConfigeGOVComponent;
    this.configComponents[
      PaymentProcessorType.PSN
    ] = PaymentAccountConfigPsnComponent;
    this.configComponents[
      PaymentProcessorType.GovPay
    ] = PaymentAccountConfigGovPayComponent;
    this.configComponents[
      PaymentProcessorType.SecurePay
    ] = PaymentAccountConfigSecurepayComponent;
    this.configComponents[
      PaymentProcessorType.Cardpointe
    ] = PaymentAccountConfigCardpointeComponent;

    this.configTypes[
      PaymentProcessorType.CertifiedPayments
    ] = CertifiedPaymentsPaymentProcessorAccountConfiguration;
    this.configTypes[
      PaymentProcessorType.ForteCheckout
    ] = ForteCheckoutPaymentProcessorAccountConfiguration;
    this.configTypes[
      PaymentProcessorType.GW
    ] = GWPaymentProcessorAccountConfiguration;
    this.configTypes[
      PaymentProcessorType.Unibank
    ] = UnibankPaymentProcessorAccountConfiguration;
    this.configTypes[
      PaymentProcessorType.CityHallSystem
    ] = CityHallSystemPaymentProcessorAccountConfiguration;
    this.configTypes[
      PaymentProcessorType.InvoiceCloud
    ] = InvoiceCloudPaymentProcessorAccountConfiguration;
    this.configTypes[
      PaymentProcessorType.OfficialPayments
    ] = OfficialpaymentsPaymentProcessorAccountConfiguration;
    this.configTypes[
      PaymentProcessorType.KanPay
    ] = KanPayPaymentProcessorAccountConfiguration;
    this.configTypes[
      PaymentProcessorType.Municipay
    ] = MunicipayPaymentProcessorAccountConfiguration;
    this.configTypes[
      PaymentProcessorType.PointNPay
    ] = PointNPayPaymentProcessorAccountConfiguration;
    this.configTypes[
      PaymentProcessorType.NMI
    ] = NmiPaymentProcessorAccountConfiguration;
    this.configTypes[
      PaymentProcessorType.VPS
    ] = VpsPaymentProcessorAccountConfiguration;
    this.configTypes[
      PaymentProcessorType.Forte
    ] = FortePaymentProcessorAccountConfiguration;
    this.configTypes[
      PaymentProcessorType.PayGov
    ] = PayGovPaymentProcessorAccountConfiguration;
    this.configTypes[
      PaymentProcessorType.Square
    ] = SquarePaymentProcessorAccountConfiguration;
    this.configTypes[
      PaymentProcessorType.eGOV
    ] = eGOVPaymentProcessorAccountConfiguration;
    this.configTypes[
      PaymentProcessorType.PSN
    ] = PSNPaymentProcessorAccountConfiguration;
    this.configTypes[
      PaymentProcessorType.GovPay
    ] = GovPayPaymentProcessorAccountConfiguration;
    this.configTypes[
      PaymentProcessorType.SecurePay
    ] = SecurepayPaymentProcessorAccountConfiguration;
    this.configTypes[
      PaymentProcessorType.Cardpointe
    ] = CardpointePaymentProcessorAccountConfiguration;
  }

  ngOnInit(): void {
    if (history.state) {
      if (history.state.paymentAccounts) {
        this.paymentAccounts = history.state.paymentAccounts;
      }
      if (history.state.feeRecipients) {
        this.feeRecipients = history.state.feeRecipients;
      }
    }

    if (this._context.client) {
      this.initData();
    } else {
      this.clientSubscription = this._context.client$.subscribe(() => {
        this.initData();
      });
    }

    this._securitySvc
      .isLoginEntitled(Actions.GENERATE_FEE_RECIPIENTS)
      .subscribe(r => (this.canGenerateFeeRecipients = r));

    this.syncUrl();
    this.routerSub$ = this._router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.syncUrl();
      });
  }

  ngOnDestroy(): void {
    if (this.clientSubscription) this.clientSubscription.unsubscribe();
    if (this.routerSub$) this.routerSub$.unsubscribe();
  }

  syncUrl() {
    const urlStr = this._router.url;
    if (urlStr.includes('/payment-accounts')) {
      this.activeTab = 'accounts';
      if (urlStr.includes('/payment-accounts/add')) {
        if (!this.showInlineEditor || this.isEditingAccount) {
          this.setupNewAccountEditor();
        }
      } else if (urlStr.includes('/payment-accounts/edit/')) {
        const id = urlStr.split('/payment-accounts/edit/')[1].split(/[?#]/)[0];
        if (this.activeEditId !== id || !this.showInlineEditor) {
          this.activeEditId = id;
          this.applyExpand();
        }
      } else {
        this.activeEditId = null;
        this.executeCloseInlineEditor();
      }
    } else if (urlStr.includes('/fee-recipients')) {
      this.activeTab = 'recipients';
      this.activeEditId = null;
      this.executeCloseInlineEditor();
    }
  }

  initData() {
    if (!this.paymentAccounts || this.paymentAccounts.length === 0) {
      this.loadPaymentAccounts();
    } else {
      this.applyExpand();
    }

    if (!this.feeRecipients || this.feeRecipients.length === 0) {
      this.loadFeeRecipients();
    }
  }

  setTab(tab: 'accounts' | 'recipients') {
    const baseUrl =
      this._router.url.split('/payment-settings')[0] + '/payment-settings';
    const stateData = {
      paymentAccounts: this.paymentAccounts,
      feeRecipients: this.feeRecipients
    };

    if (tab === 'accounts') {
      this._router.navigateByUrl(`${baseUrl}/payment-accounts/list`, {
        state: stateData
      });
    } else {
      this._router.navigateByUrl(`${baseUrl}/fee-recipients`, {
        state: stateData
      });
    }
  }

  loadPaymentAccounts() {
    this.isLoadingAccounts = true;
    this._systemSvc.getPaymentAccounts(this._context.client.id).subscribe(
      accounts => {
        this.paymentAccounts = accounts || [];
        if (!this.activeEditId) {
          this.isLoadingAccounts = false;
        }
        this.applyExpand();
      },
      err => {
        this.isLoadingAccounts = false;
        this._toastr.error('Failed to load payment accounts');
      }
    );
  }

  applyExpand() {
    if (this.activeEditId && this.paymentAccounts.length > 0) {
      const account = this.paymentAccounts.find(
        a => a.id === this.activeEditId
      );
      if (account) {
        this.executeEditAccount(account.id);
      } else {
        this.navigateToBase();
      }
    }
  }

  navigateToBase() {
    const baseUrl =
      this._router.url.split('/payment-settings')[0] +
      '/payment-settings/payment-accounts/list';
    this._router.navigateByUrl(baseUrl, {
      state: {
        paymentAccounts: this.paymentAccounts,
        feeRecipients: this.feeRecipients
      }
    });
  }

  openNewAccountEditor() {
    const baseUrl =
      this._router.url.split('/payment-settings')[0] +
      '/payment-settings/payment-accounts/add';
    this._router.navigateByUrl(baseUrl, {
      state: {
        paymentAccounts: this.paymentAccounts,
        feeRecipients: this.feeRecipients
      }
    });
  }

  setupNewAccountEditor() {
    this.editorType = 'account';
    this.isEditingAccount = false;
    this.resetAccountForms();

    this.selectedAccount = new PaymentAccount({
      clientId: this._context.client.id
    });
    this.selectedAccount.client = this._context.client;
    this.selectedAccount.processor = new PaymentProcessor();
    this.selectedProcessorName = 'Select Payment Provider';

    this.showInlineEditor = true;
    this.closeFeeReportOverlay();
    this.scrollToEditor();

    if (this.availableProcessors.length === 0) {
      this._systemSvc.getPaymentProcessors().subscribe(processors => {
        this.availableProcessors = processors || [];
      });
    }
  }

  editAccount(account: PaymentAccount) {
    const baseUrl =
      this._router.url.split('/payment-settings')[0] +
      '/payment-settings/payment-accounts/edit/' +
      account.id;
    this._router.navigateByUrl(baseUrl, {
      state: {
        paymentAccounts: this.paymentAccounts,
        feeRecipients: this.feeRecipients
      }
    });
  }

  closeInlineEditor() {
    if (this.activeTab === 'accounts') {
      this.navigateToBase();
    } else {
      this.executeCloseInlineEditor();
    }
  }

  async executeEditAccount(id: string) {
    this.editorType = 'account';
    this.isEditingAccount = true;
    this.isLoadingAccounts = true;
    this.resetAccountForms();

    try {
      this.selectedAccount = await this._systemSvc
        .getPaymentAccount(id)
        .toPromise();

      if (this.availableProcessors.length === 0) {
        const procs = await this._systemSvc.getPaymentProcessors().toPromise();
        this.availableProcessors = procs || [];
      }

      if (this.availableProcessors.length === 0) {
        this.selectedProcessorName = this.selectedAccount.processor.name;
      } else {
        const matching = this.availableProcessors.find(
          p => p.id === this.selectedAccount.processor.id
        );
        this.selectedProcessorName = matching
          ? matching.name
          : this.selectedAccount.processor.name;
      }

      this.accountForm.patchValue({
        name: this.selectedAccount.name,
        processor: this.selectedAccount.processor
      });

      this.showInlineEditor = true;
      this.closeFeeReportOverlay();
      this.scrollToEditor();

      setTimeout(() => {
        const type = this.selectedAccount.processor.type as number;
        this.loadDynamicComponents(
          type,
          this.selectedAccount.providerAccountSettings,
          this.selectedAccount.testProviderAccountSettings
        );
        this.isLoadingAccounts = false;
        this.ref.detectChanges();
      }, 100);
    } catch (e) {
      this.isLoadingAccounts = false;
      this._toastr.error('Failed to load account details');
      this.closeInlineEditor();
    }
  }

  executeCloseInlineEditor() {
    this.showInlineEditor = false;
    this.editingFeeRecipientId = null;
    this.isEditingAccount = false;
    if (this.prodItemViewContainer) this.prodItemViewContainer.clear();
    if (this.testItemViewContainer) this.testItemViewContainer.clear();
  }

  resetAccountForms() {
    this.prodForm = this.fb.group({});
    this.testForm = this.fb.group({});
    this.accountForm = this.fb.group({
      name: ['', Validators.required],
      processor: [null, Validators.required],
      prodForm: this.prodForm,
      testForm: this.testForm
    });
    this.isDropdownOpen = false;
  }

  get isModeSwitchAllowed(): boolean {
    if (!this.selectedAccount || !this.selectedAccount.processor) return false;

    if (this.selectedAccount.inTestMode) {
      return !this.selectedAccount.processor.inTestMode;
    } else {
      return false;
    }
  }

  requestToggleTestMode() {
    if (!this.isModeSwitchAllowed) {
      if (this.selectedAccount.inTestMode) {
        this._toastr.error(
          'The payment processor is in Test Mode and therefore the account cannot be made live.'
        );
      }
      return;
    }

    const action = this.selectedAccount.inTestMode
      ? 'Go Live'
      : 'Switch to Test';
    this.pendingAction = 'TOGGLE_MODE';
    this.confirmData = {
      ...this.confirmData,
      open: true,
      modalDescp: `Are you sure you want to ${action} for ${this.selectedAccount.name}?`,
      modalSubDescp:
        'This will change payment processing for all associated applications.',
      yesNoBtn: true,
      replaceYesWith: 'YES',
      replaceNoWith: 'CANCEL'
    };
  }

  requestToggleEnabled() {
    const action = this.selectedAccount.isEnabled ? 'Disable' : 'Enable';
    this.pendingAction = 'TOGGLE_ENABLED';
    this.confirmData = {
      ...this.confirmData,
      open: true,
      modalDescp: `Are you sure you want to ${action} ${this.selectedAccount.name}?`,
      modalSubDescp: this.selectedAccount.isEnabled
        ? 'This will prevent online payments.'
        : 'This will allow online payments.',
      yesNoBtn: true,
      replaceYesWith: 'YES',
      replaceNoWith: 'CANCEL'
    };
  }

  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  selectProcessor(processor: PaymentProcessor) {
    this.selectedProcessorName = processor.name;
    this.isDropdownOpen = false;
    this.accountForm.get('processor').setValue(processor);
    this.onProcessorChanged(processor);
  }

  onProcessorChanged(processor: PaymentProcessor) {
    if (!processor) return;

    this.selectedAccount.processor = processor;
    this.selectedAccount.processorId = processor.id;

    const type = processor.type;

    if (this.configTypes[type]) {
      this.selectedAccount.providerAccountSettings = new this.configTypes[
        type
      ]();
      this.selectedAccount.testProviderAccountSettings = new this.configTypes[
        type
      ]();
    } else {
      this.selectedAccount.providerAccountSettings = new PaymentProcessorAccountConfigurationBase();
      this.selectedAccount.testProviderAccountSettings = new PaymentProcessorAccountConfigurationBase();
    }

    this.prodForm = this.fb.group({});
    this.testForm = this.fb.group({});
    this.accountForm.setControl('prodForm', this.prodForm);
    this.accountForm.setControl('testForm', this.testForm);

    setTimeout(() => {
      this.loadDynamicComponents(type);
    }, 0);
  }

  loadDynamicComponents(
    type: number,
    existingProdConfig?: any,
    existingTestConfig?: any
  ) {
    const compType = this.configComponents[type];

    if (compType && this.prodItemViewContainer) {
      this.prodItemViewContainer.clear();
      this.prodComponentRef = this.prodItemViewContainer.createComponent(
        compType
      );

      this.prodComponentRef.instance.config =
        existingProdConfig || this.selectedAccount.providerAccountSettings;
      this.prodComponentRef.instance.form = this.prodForm;
      this.prodComponentRef.instance.account = this.selectedAccount;

      this.injectPlaceholders(this.prodComponentRef.location.nativeElement);
    }

    if (compType && this.testItemViewContainer) {
      this.testItemViewContainer.clear();
      this.testComponentRef = this.testItemViewContainer.createComponent(
        compType
      );

      this.testComponentRef.instance.config =
        existingTestConfig || this.selectedAccount.testProviderAccountSettings;
      this.testComponentRef.instance.form = this.testForm;
      this.testComponentRef.instance.account = this.selectedAccount;

      this.injectPlaceholders(this.testComponentRef.location.nativeElement);
    }

    this.ref.detectChanges();
  }

  private injectPlaceholders(element: HTMLElement) {
    setTimeout(() => {
      if (!element) return;
      const formGroups = element.querySelectorAll('.form-group');
      formGroups.forEach(group => {
        const label = group.querySelector('label');
        const input = group.querySelector(
          'input, select, textarea'
        ) as HTMLInputElement;
        if (label && input && !input.getAttribute('placeholder')) {
          const labelText = label.innerText.trim();
          input.setAttribute('placeholder', labelText);
        }
      });
    }, 50);
  }

  saveAccount() {
    if (
      this.accountForm.get('name').invalid ||
      this.accountForm.get('processor').invalid
    ) {
      this.accountForm.markAllAsTouched();
      return;
    }

    this.isSaving = true;
    const formVal = this.accountForm.value;
    this.selectedAccount.name = formVal.name;

    this._systemSvc.savePaymentAccount(this.selectedAccount).subscribe(
      success => {
        this._systemSvc.getPaymentAccounts(this._context.client.id).subscribe(
          accounts => {
            this.paymentAccounts = accounts || [];
            this.isSaving = false;
            this._toastr.success('Payment Account Saved');
            this.closeInlineEditor();
          },
          err => {
            this.isSaving = false;
            this._toastr.error('Account saved, but failed to refresh list.');
            this.closeInlineEditor();
          }
        );
      },
      err => {
        this.isSaving = false;
        this._toastr.error('Error saving account');
      }
    );
  }

  requestRemoveAccount(id: string) {
    this.pendingAction = 'DELETE_ACCOUNT';
    this.pendingId = id;
    this.confirmData = {
      ...this.confirmData,
      open: true,
      modalDescp: 'Are you sure you want to remove this payment account?',
      modalSubDescp:
        'Online payments will stop for applications using this account.',
      yesNoBtn: true,
      replaceYesWith: 'REMOVE',
      replaceNoWith: 'CANCEL'
    };
  }

  loadFeeRecipients() {
    this._clientSvc
      .getFeeRecipients(this._context.client.id)
      .subscribe(fr => (this.feeRecipients = fr || []));
  }

  openNewRecipientEditor() {
    this.editorType = 'recipient';
    this.editingFeeRecipientId = null;
    this.recipientForm.reset();
    this.showInlineEditor = true;
    this.closeFeeReportOverlay();
    this.scrollToEditor();
  }

  editRecipient(r: FeeRecipient) {
    this.editorType = 'recipient';
    this.editingFeeRecipientId = r.id;
    this.recipientForm.patchValue({ name: r.value });
    this.showInlineEditor = true;
    this.closeFeeReportOverlay();
    this.scrollToEditor();
  }

  saveRecipient() {
    if (this.recipientForm.invalid) {
      this.recipientForm.markAllAsTouched();
      return;
    }
    this.isSaving = true;
    const recipientToSave = new FeeRecipient();
    recipientToSave.clientId = this._context.client.id;
    recipientToSave.value = this.recipientForm.value.name;

    if (this.editingFeeRecipientId) {
      recipientToSave.id = this.editingFeeRecipientId;
    } else {
      recipientToSave.id = Utilities.generateId();
    }

    this._systemSvc.saveFeeRecipient(recipientToSave).subscribe(
      result => {
        this.isSaving = false;
        this._toastr.success('Fee Recipient Saved');
        if (this.editingFeeRecipientId) {
          const idx = this.feeRecipients.findIndex(r => r.id === result.id);
          if (idx > -1) this.feeRecipients[idx] = result;
        } else {
          this.feeRecipients.push(result);
        }

        this.executeCloseInlineEditor();
      },
      err => {
        this.isSaving = false;
        this._toastr.error('Error saving fee recipient');
      }
    );
  }

  requestDeleteRecipient(id: string) {
    this.pendingAction = 'DELETE_RECIPIENT';
    this.pendingId = id;
    this.confirmData = {
      ...this.confirmData,
      open: true,
      modalDescp: 'Are you sure you want to delete this Fee Recipient?',
      modalSubDescp: 'This action cannot be undone.',
      yesNoBtn: true,
      replaceYesWith: 'DELETE',
      replaceNoWith: 'CANCEL'
    };
  }

  initiateFeeGeneration() {
    this.feeRecipientGenerationImpactReport = null;
    this.waitingOnReport = true;

    this._clientSvc
      .getFeeRecipientGenerationImpactReport(this._context.client.id)
      .subscribe(report => {
        this.waitingOnReport = false;
        if (
          report &&
          report.impactedWorkflows &&
          report.impactedWorkflows.length > 0
        ) {
          this.feeRecipientGenerationImpactReport = report;
          this.showFeeReportOverlay = true;
          this.executeCloseInlineEditor();
          this.scrollToOverlay();
        } else {
          this.confirmData = {
            ...this.confirmData,
            open: true,
            modalDescp: 'No Fee Recipients found.',
            modalSubDescp:
              'No Fee Recipients were found on Fee Data Entities in any Workflow designs.',
            yesNoBtn: false,
            replaceYesWith: 'OK',
            replaceNoWith: ''
          };
        }
      });
  }

  closeFeeReportOverlay() {
    this.showFeeReportOverlay = false;
    this.feeRecipientGenerationImpactReport = null;
  }

  confirmFeeGeneration() {
    this.executeGeneration();
    this.closeFeeReportOverlay();
  }

  onConfirmYes() {
    if (this.pendingAction === 'DELETE_ACCOUNT' && this.pendingId) {
      const idToRemove = this.pendingId;
      this._systemSvc.deletePaymentAccount(idToRemove).subscribe(() => {
        this._toastr.success('Payment Account Removed');

        this.paymentAccounts = this.paymentAccounts.filter(
          a => a.id !== idToRemove
        );

        if (this.activeEditId === idToRemove) {
          this.closeInlineEditor();
        }
      });
    } else if (this.pendingAction === 'DELETE_RECIPIENT' && this.pendingId) {
      const idToRemove = this.pendingId;
      this._systemSvc.deleteFeeRecipient(idToRemove).subscribe(success => {
        if (success) {
          this._toastr.success('Fee Recipient Deleted');

          this.feeRecipients = this.feeRecipients.filter(
            r => r.id !== idToRemove
          );

          if (this.editingFeeRecipientId === idToRemove) {
            this.executeCloseInlineEditor();
          }
        }
      });
    } else if (this.pendingAction === 'TOGGLE_MODE') {
      this.selectedAccount.inTestMode = !this.selectedAccount.inTestMode;
      this.saveAccount();
    } else if (this.pendingAction === 'TOGGLE_ENABLED') {
      if (this.selectedAccount.isEnabled) {
        this._systemSvc
          .disablePaymentAccount(this.selectedAccount.id)
          .subscribe(() => {
            this.selectedAccount.isEnabled = false;
            this._toastr.success('Payment Account Disabled');
          });
      } else {
        this._systemSvc
          .enablePaymentAccount(this.selectedAccount.id)
          .subscribe(() => {
            this.selectedAccount.isEnabled = true;
            this._toastr.success('Payment Account Enabled');
          });
      }
    }
    this.closeConfirm();
  }

  onConfirmNo() {
    this.closeConfirm();
  }

  private closeConfirm() {
    this.confirmData = { ...this.confirmData, open: false };
    this.pendingAction = null;
    this.pendingId = null;
  }

  private executeGeneration() {
    if (!this.feeRecipientGenerationImpactReport) return;

    let workflowFeeRecipientItems: WorkflowFeeRecipientItem[] = [];
    for (let wi of this.feeRecipientGenerationImpactReport.impactedWorkflows) {
      for (let activityId in wi.feeEntityActivities) {
        const templateCodes = wi.feeEntityActivities[activityId];
        const wfris = templateCodes.map(
          tc =>
            new WorkflowFeeRecipientItem({
              draftVersionId: wi.draftVersionId,
              activityId: activityId,
              templateCode: tc
            })
        );
        workflowFeeRecipientItems.push(...wfris);
      }
    }
    const request = new FeeRecipientGenerationRequest({
      workflowFeeRecipientItems
    });
    this._clientSvc.generateFeeRecipients(request).subscribe(response => {
      if (response.success) {
        this.feeRecipients = response.newFeeRecipients;
        this._toastr.success('Fee Recipients Generated');
      } else {
        this._toastr.error('Error generating Fee Recipients.');
      }
    });
  }

  scrollToEditor() {
    setTimeout(() => {
      const el = document.querySelector(
        '.new-item-inline'
      ) as HTMLElement | null;
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }, 10);
  }

  scrollToOverlay() {
    setTimeout(() => {
      const el = document.querySelector(
        '.overlay-section'
      ) as HTMLElement | null;
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }, 10);
  }
}
